import { gql } from '@apollo/client';
import { DomainFragment } from 'Apollo/fragments/domain/Domain';

export const GetOrganizationDomains = gql`
  query GetOrganizationDomains($code: String!, $page: PageInput) {
    organizationDomains(code: $code, page: $page) {
      edges {
        node {
          ...Domain
        }
      }
      pageInfo {
        hasNextPage
      }
      totalCount
    }
  }
  ${DomainFragment}
`;
